import { Serializable, JsonProperty } from 'typescript-json-serializer';
import { ProfileGroup } from './ProfileGroup';

@Serializable()
export class Profile {

    code?:string;

    @JsonProperty()
    _id: string;

    @JsonProperty()
    clazz: string;

    @JsonProperty()
    modifiedDate: number;

    @JsonProperty()
    modifiedBy: string;

    @JsonProperty()
    name: string;

    @JsonProperty()
    sort: number;

    @JsonProperty()
    productId: number;

    @JsonProperty()
    groups: Array<ProfileGroup>;

    @JsonProperty()
    multilingualKey: string;
}

